(function () {
  'use strict';

  /* ── 1. Smooth scroll for all anchor links ── */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ── 2. Scroll-triggered entrance animations ── */
  if ('IntersectionObserver' in window) {
    var animObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('klense-visible');
          animObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.klense-animate').forEach(function (el) {
      animObserver.observe(el);
    });
  } else {
    // Fallback for older browsers — show everything immediately
    document.querySelectorAll('.klense-animate').forEach(function (el) {
      el.classList.add('klense-visible');
    });
  }

  /* ── 3. Sticky mobile bar — show between hero and product CTA ── */
  var bar = document.getElementById('klense-sticky-bar');
  if (bar) {
    var hero = document.querySelector('.klense-hero');
    var pcta = document.querySelector('.klense-pcta');

    function updateBar() {
      var heroGone = hero ? hero.getBoundingClientRect().bottom < 80 : true;
      var pctaVisible = pcta
        ? pcta.getBoundingClientRect().top < window.innerHeight - 60
        : false;

      if (heroGone && !pctaVisible) {
        bar.classList.add('klense-sticky-bar--visible');
      } else {
        bar.classList.remove('klense-sticky-bar--visible');
      }
    }

    window.addEventListener('scroll', updateBar, { passive: true });
    updateBar();
  }

})();
